/* eslint-disable no-underscore-dangle */
// @ts-nocheck
import { takeLatest, put, select, call } from 'redux-saga/effects';
import { setNotification, operatorTyping } from 'utils';
import { delay } from 'redux-saga';
import { compact, uniq } from 'lodash';
import {
    LOAD_COATING_OUT,
    CREATE_JOB_PALETTE,
    LOAD_JOB_PALETTES_OUT,
    DELETE_COATING_OUT_JOB,
    CONFIRM_PALETTE,
    ADD_NEW_PALETTE_OUT,
    PRINT_PALETTE_OUT,
} from '../types/coatingOutTypes';
import { toggleJobStatusApi } from '../api/jobApi';
import {
    getCoatingOutApi,
    createJobPaletteCoatingOutApi,
    getJobPalettesOutApi,
} from '../api/coatingOutApi';
import {
    addNewPaletteApi,
    toggleJobResultStepsApi,
    getJobResultApi,
} from '../api/jobResultApi';
import {
    loadCoatingOutRes,
    loadCoatingOutErr,
    createJobPaletteRes,
    createJobPaletteErr,
    loadJobPalettesOutRes,
    loadJobPalettesOutErr,
    deleteCoatingOutJobRes,
    deleteCoatingOutJobErr,
    confirmPaletteRes,
    confirmPaletteErr,
    setCheckedJobResultRecordOut,
    addNewPaletteOutRes,
    addNewPaletteOutErr,
    printPaletteOutRes,
    printPaletteOutErr,
} from '../actions/coatingOutActions';
import { getPrepressApi } from '../api/prepressApi';

const getLayout = state => state.layout;
const getCoatingOut = state => state.coatingOut;

// L O A D   C O A T I N G   O U T
function* loadCoatingOutSaga() {
    const { filters } = yield select(getCoatingOut);
    try {
        const params = {
            limit: 999,
            offset: 0,
            sort_by: JSON.stringify({ start_date: 1 }),
            joins: JSON.stringify(['job', 'order_item']),
            filter: { machine_id: process.env.REACT_APP_MACHINE_COATING_IN_LINE },
        };

        const filterParams = {};

        if (filters.order_id !== '') {
            filterParams.join = {
                'order_item.order_number': operatorTyping(filters.order_id),
            };
        }

        if (filters.order_item_id !== '') {
            filterParams.join = {
                ...filterParams.join,
                'order_item.order_item_number': operatorTyping(filters.order_item_id),
            };
        }

        if (filters.customer !== '') {
            filterParams.join = {
                ...filterParams.join,
                'order_item.customer_name': operatorTyping(filters.customer),
            };
        }

        params.filter = JSON.stringify({ ...params.filter, ...filterParams });

        const result = yield getCoatingOutApi(params);

        if (result.status === 200) {
            const { hits } = result.data;

            const orderItemIDS = uniq(compact(hits.map(hit => hit.order_item_id)));

            const oiSplitIDS = [];
            let split = 100;
            let index = 0;
            let isSpliting = true;
            while (isSpliting) {
                const part = orderItemIDS.slice(index, split);

                if (part.length > 0) {
                    oiSplitIDS.push(part);
                    index = split;
                    split += index;
                } else {
                    isSpliting = false;
                }
            }

            const errorList = [];

            for (let i = 0; i < oiSplitIDS.length; i += 1) {
                try {
                    const resultErrors = yield getPrepressApi({
                        filter: JSON.stringify({ order_item_id: oiSplitIDS[i], status: ['NEW', 'FIXED'] }),
                        limit: oiSplitIDS[i].length * 10,
                    });

                    const list = compact(hits.map((hit) => {
                        const errors = (resultErrors.data?.hits || []).filter(err => (
                            err.order_item_id === hit.order_item_id
                            && err.job_id === hit.job_id
                            && err.machine_id === process.env.REACT_APP_MACHINE_COATING_IN_LINE
                        ));

                        return { ...hit, error: errors.reduce((acc, curr) => acc + curr.quantity, 0) };
                    }));

                    errorList.push(list);
                } catch (error) {
                    console.log(error);
                }
            }

            yield put(loadCoatingOutRes({ ...result.data, hits: errorList.flat(2) }));
        }
    } catch (e) {
        console.log(e);
        yield put(loadCoatingOutErr());
    }
}

export function* loadCoatingOutWatcher() {
    yield takeLatest(LOAD_COATING_OUT, loadCoatingOutSaga);
}
// L O A D   C O A T I N G   O U T

// L O A D   J O B   P A L E T T E S   O U T
function* loadJobPalettesOutSaga() {
    const { filtersJobPalettesOut } = yield select(getCoatingOut);
    try {
        const coatingOut = yield select(getCoatingOut);

        const { checked } = coatingOut;

        const params = {
            limit: 999,
            offset: 0,
            sort_by: JSON.stringify({ created_at: -1 }),
            joins: JSON.stringify(['job', 'order_item']),
            filter: { current_machine: process.env.REACT_APP_MACHINE_COATING_IN_LINE, parent: 'notnull', palette_number: null },
        };

        const filterParams = {};

        if (filtersJobPalettesOut.order_id !== '') {
            filterParams.join = {
                'order_item.order_number': operatorTyping(filtersJobPalettesOut.order_id),
            };
        }

        if (filtersJobPalettesOut.order_item_id !== '') {
            filterParams.join = {
                ...filterParams.join,
                'order_item.order_item_number': operatorTyping(filtersJobPalettesOut.order_item_id),
            };
        }

        if (filtersJobPalettesOut.customer !== '') {
            filterParams.join = {
                ...filterParams.join,
                'order_item.customer_name': operatorTyping(filtersJobPalettesOut.customer),
            };
        }

        params.filter = JSON.stringify({ ...params.filter, ...filterParams });

        const result = yield getJobPalettesOutApi(params);

        if (result.status === 200) {
            yield put(loadJobPalettesOutRes(result.data));
            yield put(setCheckedJobResultRecordOut(result.data.hits.filter(hit => checked.ids.includes(hit._id))));
        }
    } catch (e) {
        console.log(e);
        yield put(loadJobPalettesOutErr());
    }
}

export function* loadJobPalettesOutWatcher() {
    yield takeLatest(LOAD_JOB_PALETTES_OUT, loadJobPalettesOutSaga);
}
// L O A D   J O B   P A L E T T E S   O U T

// C R E A T E   J O B   P A L E T T E
function* createJobPaletteSaga(action) {
    const { locale } = yield select(getLayout);
    const coatingOut = yield select(getCoatingOut);

    const { isTotalQuantitySelected } = coatingOut;

    try {
        const currentJob = coatingOut.listing.hits.find(hit => hit.job_id === action.data.job_id);

        const result = yield createJobPaletteCoatingOutApi(action.data);

        if (result.status === 202) {
            if (isTotalQuantitySelected) {
                const data = {
                    job_id: currentJob.job_id,
                    machine_id: currentJob.machine_id,
                    step_state: 'DONE',
                };
                yield toggleJobStatusApi(data);
            }

            yield put(createJobPaletteRes(true));
            yield delay(1000);
            yield put(createJobPaletteRes(false));
            setNotification('success', locale, 'global.success', 'coatingOut.notification.createJobResultSuccess');
            yield put({ type: LOAD_COATING_OUT });
            yield put({ type: LOAD_JOB_PALETTES_OUT });
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(createJobPaletteErr());
        }
    } catch (e) {
        yield put(createJobPaletteErr());
        setNotification('error', locale, 'global.error', 'coatingOut.notification.createJobResultError');
        console.log(e);
    }
}

export function* createJobPaletteWatcher() {
    yield takeLatest(CREATE_JOB_PALETTE, createJobPaletteSaga);
}
// C R E A T E   J O B   P A L E T T E

// D E L E T E   J O B   C O A T I N G   O U T
function* deleteJobCoatingOutSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield createJobPaletteCoatingOutApi(action.data);

        if (result.status === 202) {
            yield put(deleteCoatingOutJobRes(true));
            yield delay(1000);
            yield put(deleteCoatingOutJobRes(false));
            setNotification('success', locale, 'global.success', 'coatingOut.notification.deleteJobSuccess');
            yield put({ type: LOAD_COATING_OUT });
            yield put({ type: LOAD_JOB_PALETTES_OUT });
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(deleteCoatingOutJobErr());
        }
    } catch (e) {
        yield put(deleteCoatingOutJobErr());
        setNotification('error', locale, 'global.error', 'coatingOut.notification.deleteJobError');
        console.log(e);
    }
}

export function* deleteJobCoatingOutWatcher() {
    yield takeLatest(DELETE_COATING_OUT_JOB, deleteJobCoatingOutSaga);
}
// D E L E T E   J O B   C O A T I N G   O U T


// E N D   J O B   R E S U L T   O U T   S T E P S
function* endJobResultOutStepsSaga() {
    const coatingOut = yield select(getCoatingOut);

    let validJobResults = [];

    validJobResults = coatingOut.checked.selected.filter(jp => !jp.palette_number);

    let readyStepsCount = 0;
    const params = {
        bulk: [],
    };

    function isAlreadyFinished(jp) {
        return jp.next_machine === null && jp.current_machine === null;
    }

    function isReadyToStop(jp) {
        return jp.current_machine !== null;
    }

    function buildToggleParameters(readyJobResultsOut) {
        if (readyStepsCount !== 0) {
            readyJobResultsOut.forEach((jp) => {
                params.bulk.push({
                    job_palette_id: jp._id,
                    machine_id: jp.current_machine,
                    state: 'end',
                });
            });
        }
    }

    try {
        if (!validJobResults.every(isAlreadyFinished)) {
            const readyToStopJobResultsOut = validJobResults.filter(isReadyToStop);
            readyStepsCount = readyToStopJobResultsOut.length;
            buildToggleParameters(readyToStopJobResultsOut);

            if (readyStepsCount !== 0) {
                yield toggleJobResultStepsApi(params);
            }
        }
    } catch (e) {
        console.log(e);
    }
}
// E N D   J O B   R E S U L T   O U T   S T E P S

// C O N F I R M   P A L E T T E   C O A T I N G   O U T
function* confirmPaletteCoatingOutSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const params = { bulk: [] };

        action.jobPalettesIds.forEach((e) => {
            params.bulk.push({
                job_palette_id: e,
                machine_id: action.machineId,
                state: 'end',
            });
        });

        const result = yield toggleJobResultStepsApi(params);

        if (result.status === 202) {
            const paramsJobPalette = {};
            paramsJobPalette.filter = JSON.stringify({
                palette_number: action.paletteNumber,
            });
            const resultJobPalette = yield getJobResultApi(paramsJobPalette);

            yield put(confirmPaletteRes(action.paletteId));
            setNotification('success', locale, 'global.success', 'coatingOut.notification.confirmPaletteSuccess');
            yield put({ type: LOAD_COATING_OUT });
            yield delay(1000);
            if (resultJobPalette.status === 200) {
                window.open(`${process.env.REACT_APP_CDN}job-palettes/${resultJobPalette.data.hits[0].pdf_file}`, '_blank');
            } else {
                const error = yield result.json();
                setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            }
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(confirmPaletteErr());
        }
    } catch (e) {
        yield put(confirmPaletteErr());
        setNotification('error', locale, 'global.error', 'coatingOut.notification.confirmPaletteError');
        console.log(e);
    }
}

export function* confirmPaletteCoatingOutWatcher() {
    yield takeLatest(CONFIRM_PALETTE, confirmPaletteCoatingOutSaga);
}
// C O N F I R M   P A L E T T E   C O A T I N G   O U T

// A D D   N E W   P A L E T T E   O U T
function* addNewPaletteOutSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        yield call(endJobResultOutStepsSaga);
        const result = yield addNewPaletteApi(action.data);

        if (result.status === 202) {
            setNotification('success', locale, 'global.success', 'jobResult.notification.addNewPalette.success');
            yield call(loadJobPalettesOutSaga, {});
            yield put(addNewPaletteOutRes());
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(addNewPaletteOutErr());
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'jobResult.notification.addNewPalette.error');
        console.log(e);
    }
}

export function* addNewPaletteOutWatcher() {
    yield takeLatest(ADD_NEW_PALETTE_OUT, addNewPaletteOutSaga);
}
// A D D   N E W   P A L E T T E   O U T

// P R I N T   P A L E T T E   O U T
function* printPaletteOutSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = { };

        const filterParams = {
            _id: action.data,
        };

        params.filter = JSON.stringify(filterParams);

        const result = yield getJobResultApi(params);

        if (result.status === 200) {
            window.open(`${process.env.REACT_APP_CDN}job-palettes/${result.data.hits[0].pdf_file}`, '_blank');
            yield put(printPaletteOutRes());
        } else {
            setNotification('error', locale, 'global.error', 'jobResult.notification.printPalette.error');
            yield put(printPaletteOutErr());
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'jobResult.notification.printPalette.error');
        yield put(printPaletteOutErr());
    }
}

export function* printPaletteOutWatcher() {
    yield takeLatest(PRINT_PALETTE_OUT, printPaletteOutSaga);
}
// P R I N T   P A L E T T E   O U T
